import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 本地使用代理路径，其他模式使用正式服务器完整接口地址
  timeout: 10000 // 请求超时时间
})

// request 拦截器（携带Token）
service.interceptors.request.use(
  config => {
    // 真实接口要求携带Token（从store取，接口文档未指定Bearer，直接赋值）
    if (store.state.user.token) {
      // 注意：若后端要求Bearer格式，改为：'Bearer ' + store.state.user.token
      config.headers['Authorization'] = `Bearer ${store.state.user.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response 拦截器（适配真实接口的code=200成功码）
// response 拦截器（适配真实接口的code=200成功码 + 兼容文件流导出）
service.interceptors.response.use(
    response => {
      // 新增：判断是否为文件流响应（两种判断方式，任选其一或结合使用）
      const isBlobResponse = 
        // 方式1：通过请求配置的responseType判断（推荐，更精准）
        response.config.responseType === 'blob' || 
        response.config.responseType === 'arraybuffer' ||
        // 方式2：通过响应头的Content-Type判断（兼容后端未明确返回responseType的场景）
        (response.headers['content-type'] && 
         (response.headers['content-type'].includes('application/octet-stream') ||
          response.headers['content-type'].includes('spreadsheetml')));
      
      // 如果是文件流响应，直接返回原始response（不进行JSON的code校验）
      if (isBlobResponse) {
        return response;
      }
  
      // 非文件流响应，继续执行原有JSON格式校验逻辑
      const res = response.data;
      const successCode = [200, 0];
      if (!successCode.includes(res.code)) {
        Message({
          message: res.msg || '请求失败',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error(res.msg || '请求失败'))
      } else {
        return res
      }
    },
    error => {
      console.log('err' + error)
      Message({
        message: error.message || '接口请求异常',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )

export default service
